module.exports = __webpack_public_path__ + "img/batteri-ladeniveau-forside_hvid_2.35d6e6fe.svg";